(() => {
  if (window.location.hostname !== 'naturesblends.nl' || window.nbNlConsentBridgeStarted) return;
  window.nbNlConsentBridgeStarted = true;
  const layer = window.nbNlTagData = window.nbNlTagData || [];
  const command = function () { layer.push(arguments); };
  let previous = '';
  command('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied',
    wait_for_update: 500
  });
  command('set', 'ads_data_redaction', true);
  command('set', 'url_passthrough', false);
  command('set', 'allow_ad_personalization_signals', false);

  function sync() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    const choice = privacy.currentVisitorConsent();
    const analytics = choice.analytics === 'yes' && privacy.analyticsProcessingAllowed();
    const marketing = choice.marketing === 'yes' && privacy.marketingAllowed();
    const state = {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: 'denied'
    };
    const signature = JSON.stringify(state);
    if (signature === previous) return;
    previous = signature;
    command('consent', 'update', state);
    layer.push({ event: 'nl_consent_updated', analytics_allowed: analytics, marketing_allowed: marketing });
  }

  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify && window.Shopify.customerPrivacy) {
    sync();
  } else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) sync();
    });
  }
  layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MCFP2NWF&l=nbNlTagData';
  document.head.appendChild(script);
})();
